import React from 'react';
import { Box, Button, Loader } from '@iclinic/design-system';

import {
  CardStyled,
  HeadingContainer,
  Heading,
  Body,
  Image,
  ButtonContainer,
  LoadingContainer,
} from './Card.styles';

export type CardProps = {
  title: string;
  text: string;
  imagePath: string;
  imageAlt: string;
  dataGa?: string;
  onClickEvent: (e: React.MouseEvent<HTMLElement>) => unknown;
  isLoading?: boolean;
};

const Card = ({
  title,
  text,
  imagePath,
  imageAlt,
  dataGa = '',
  onClickEvent,
  isLoading,
}: CardProps) => {
  const onClick = (e: React.MouseEvent) => e.stopPropagation();

  return (
    <CardStyled data-ga={dataGa} onClick={onClickEvent}>
      <HeadingContainer>
        <Heading variant="sm" inverseTextColor>
          {title}
        </Heading>
        <Body variant="xs" inverseTextColor>
          {text}
        </Body>
      </HeadingContainer>
      <Image src={imagePath} alt={imageAlt} />
      <ButtonContainer>
        <Button
          color="secondary"
          variant="contained"
          size="small"
          onClick={onClickEvent}
        >
          Conhecer
        </Button>
      </ButtonContainer>
      {isLoading && (
        <LoadingContainer onClick={onClick}>
          <Box width="40px">
            <Loader />
          </Box>
        </LoadingContainer>
      )}
    </CardStyled>
  );
};

export default Card;
